import { DateTime } from 'luxon';
import type { DecoratedEntry, DecoratedInstance } from '@/pages/Schedule/types';

export const isInstanceInThePast = (
  entry: DecoratedEntry,
  instance?: DecoratedInstance
): boolean => {
  const isSeriesInstance = !!instance?.rule;
  const endDate = isSeriesInstance
    ? instance.endDate
    : entry.recurrences[0].endDate;
  return endDate < DateTime.local();
};
